// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1038":"032fbfab","1479":"037f112f","6240":"d0a27a35","7207":"5856fef0"}[chunkId] + ".chunk.css";
};